module.exports = __webpack_public_path__ + "assets/img/logo.8b0f603b.png";